import { MyTimeAdminSettingsPage } from "my-time/pages/admin-settings-page";
import { MyTimeApproveRequestsPage } from "my-time/pages/approve-requests-page";
import { MyTimeClosingCurrentPeriodPage } from "my-time/pages/closing-current-period-page";
import { MyTimeEmployeeRequestPage } from "my-time/pages/employee-request-page";
import { MyTimeEmployeeRequestsPage } from "my-time/pages/employee-requests-page";
import { MyTimeEmployeeSchedulePage } from "my-time/pages/employee-schedule-page/employee-schedule-page";
import { MyTimeExaminerDashboardPage } from "my-time/pages/examiner-dashboard-page";
import { MyTimeShowRequestPage } from "my-time/pages/show-request-page";

export const myTimeEmployeeSchedulePageRoutePath = "/my-time/employee-schedule";
export const myTimeApproveRequestsPageRoutePath = "/my-time/approve-requests";
export const myTimeEmployeeRequestsPageRoutePath =
  "/my-time/employee-requests/:employee/:contract";
export const myTimeEmployeeRequestPageRoutePath =
  "/my-time/employee-request/:employee/:contract/:id";
export const myTimeClosingPeriodPageRoutePath =
  "/my-time/closing-current-period";
export const myTimeShowRequestPageRoutePath =
  "/my-time/show-request/:employee/:contract/:id";
export const myTimeAdminSettingsPageRoutePath = "/my-time/admin/settings";
export const myTimeExaminerDashboardPageRoutePath =
  "/my-time/examiner-dashboard";

export const buildMyTimeEmployeeRequestsPageRoutePath = (
  employee: string,
  contract: string,
) => {
  return `/my-time/employee-requests/${employee}/${contract}`;
};

export const buildMyTimeEmployeeRequestPageRoutePath = (
  employee: string,
  contract: string,
  id: string,
) => {
  return `/my-time/employee-request/${employee}/${contract}/${id}`;
};

export const buildMyTimeShowRequestPageRoutePath = (
  employee: string,
  contract: string,
  id: string,
) => {
  return `/my-time/show-request/${employee}/${contract}/${id}`;
};

export const myTimeRoutes = [
  {
    id: "myTimeEmployeeSchedulePageRoute",
    path: myTimeEmployeeSchedulePageRoutePath,
    exact: true,
    private: true,
    component: MyTimeEmployeeSchedulePage,
    roles: ["MyTime.user"],
  },
  {
    id: "myTimeApproveRequestsPageRoute",
    path: myTimeApproveRequestsPageRoutePath,
    exact: true,
    private: true,
    component: MyTimeApproveRequestsPage,
    roles: ["MyTime.examiner"],
  },
  {
    id: "myTimeEmployeeRequestsPageRoute",
    path: myTimeEmployeeRequestsPageRoutePath,
    exact: true,
    private: true,
    component: MyTimeEmployeeRequestsPage,
    roles: ["MyTime.examiner"],
  },
  {
    id: "myTimeEmployeeRequestPageRoute",
    path: myTimeEmployeeRequestPageRoutePath,
    exact: true,
    private: true,
    component: MyTimeEmployeeRequestPage,
    roles: ["MyTime.examiner"],
  },
  {
    id: "myTimeClosingPeriodPageRoute",
    path: myTimeClosingPeriodPageRoutePath,
    exact: true,
    private: true,
    component: MyTimeClosingCurrentPeriodPage,
    roles: ["MyTime.admin"],
  },
  {
    id: "myTimeShowRequestPageRoute",
    path: myTimeShowRequestPageRoutePath,
    exact: true,
    private: true,
    component: MyTimeShowRequestPage,
    roles: ["MyTime.user", "MyTime.examiner", "MyTime.admin"],
  },
  {
    id: "myTimeAdminSettingsPageRoute",
    path: myTimeAdminSettingsPageRoutePath,
    exact: true,
    private: true,
    component: MyTimeAdminSettingsPage,
    roles: ["MyTime.admin"],
  },
  {
    id: "myTimeExaminerDashboardPageRoute",
    path: myTimeExaminerDashboardPageRoutePath,
    exact: true,
    private: true,
    component: MyTimeExaminerDashboardPage,
    roles: ["MyTime.examiner"],
  },
];
